import {Typography, Select} from "antd";
import {getPopupSizeOption, amountFormatter} from '../Common/util';
import {ynSelectOptions} from '../Common/options';

export function onClickDetailHandler(value) {
    
    if (value.columnType == 'assetReport') {

        var _width = '1600';
        var _height = '1400';
        const option = getPopupSizeOption(_width, _height);

        const url = '#/report/'+value.columnType+'/'+value.report_id+'/'+value.asset_cd+'/'+value.com_cd+'/'+value.asset_type;
        const target = value.columnType;
        window.open(url, target, option);
    
    } 

};

// Measure 목록
export const measureColumnData = [
    {
        title: '분류',
        dataIndex: 'measure_type',
        key: 'measure_type',
        width: '70px',
        align: 'center',
        ellipsis : true,
        editable: false,
        sorter: {
            compare: (a, b) => a.measure_type.localeCompare(b.measure_type),
        },
    },
    {
        title: '진단코드',
        dataIndex: 'measure_cd',
        key: 'measure_cd',
        width: '100px',
        align: 'center',
        ellipsis : true,
        editable: false,
        sorter: {
            compare: (a, b) => a.measure_cd.localeCompare(b.measure_cd),
        },
    },
    {
        title: '진단항목',
        dataIndex: 'measure_nm',
        key: 'measure_nm',
        width: '250px',
        align: 'left',
        ellipsis : true,
        editable: false,
        sorter: {
            compare: (a, b) => a.measure_nm.localeCompare(b.measure_nm),
        },
    },
    {
        title: '사용',
        dataIndex: 'use_yn',
        key: 'use_yn',
        width: '60px',
        align: 'center',
        ellipsis : true,
        editable: true,
        sorter: {
            compare: (a, b) => a.use_yn?.localeCompare(b.use_yn),
        },
        render: (_ , rowData ) => {
            if(rowData.use_yn === 'N' || rowData.use_yn === 'n') {
                return (
                    <span style={{color: 'red', fontWeight: 'bold'}}>
                        {rowData.use_yn}
                    </span>
                )
            }else{
                return (
                    <span style={{color: 'black'}}>
                        {rowData.use_yn}
                    </span>
                );
            }
       } 
        // render: (_ , rowData ) => {
        //     let confidential = (rowData.user_yn==="" || rowData.user_yn == null ? 'Y' : rowData.user_yn);
        //     return (
        //         confidential
        //     );
        // },        
        // render: (_ , rowData ) => {
        //     let confidential = (rowData.user_yn === "" || rowData.user_yn == null ? 'Y' : rowData.user_yn);
        //     return (
        //         <Select defaultValue={confidential} options={ynSelectOptions} style={{width: '100%'}}
        //         />
        //     );
        // },
    },
    {
        title: '중요도',
        dataIndex: 'important_grd',
        key: 'important_grd',
        width: '70px',
        align: 'center',
        editable: false,
        sorter: {
            compare: (a, b) => a.important_grd.localeCompare(b.important_grd),
        },
    },
    {
        title: '위협코드',
        dataIndex: 'threat_cd',
        key: 'threat_cd',
        width: '70px',
        align: 'center',
        editable: false,
        sorter: {
            compare: (a, b) => a.threat_cd.localeCompare(b.threat_cd),
        },
    },
    {
        title: '구축비용 기준',
        dataIndex: 'cost_measure',
        key: 'cost_measure',
        width: '60px',
        align: 'center',
        editable: false,
        sorter: {
            compare: (a, b) => a.cost_measure - b.cost_measure,
        },
    },
    {
        title: '위험도 기준',
        dataIndex: 'risk_measure',
        key: 'risk_measure',
        width: '60px',
        align: 'center',
        editable: false,
        sorter: {
            compare: (a, b) => a.risk_measure - b.risk_measure,
        },
    },
    {
        title: '난이도 기준',
        dataIndex: 'difficulty_measure',
        key: 'difficulty_measure',
        width: '60px',
        align: 'center',
        editable: false,
        sorter: {
            compare: (a, b) => a.difficulty_measure - b.difficulty_measure,
        },
    },
    {
        title: '합계',
        dataIndex: 'sum_measure',
        key: 'sum_measure',
        width: '70px',
        align: 'center',
        render: (_ , rowData ) => {
            return (
                amountFormatter(Number(rowData.cost_measure) + Number(rowData.risk_measure) + Number(rowData.difficulty_measure))
            );
        },
        className: 'fix_col',
        sorter: {
            compare: (a, b) => a.sum_measure - b.sum_measure,
        },
    },
    {
        title: '적용시기',
        dataIndex: 'apply_time',
        key: 'apply_time',
        width: '70px',
        align: 'center',
        editable: false,
        sorter: {
            compare: (a, b) => a.apply_time.localeCompare(b.apply_time),
        },
    },
    {
        title: '대응전략',
        dataIndex: 'apply_action',
        key: 'apply_action',
        width: '70px',
        align: 'center',
        editable: false,
        sorter: {
            compare: (a, b) => a.apply_action.localeCompare(b.apply_action),
        },
    },
];



// Suggest 목록
export const suggestColumnData = [
    {
        title: '진단코드',
        dataIndex: 'measure_cd',
        key: 'measure_cd',
        width: '70px',
        align: 'center',
        editable: false,
        sorter: {
            compare: (a, b) => a.measure_cd.localeCompare(b.measure_cd),
        },
    },
    // {
    //     title: '자산유형',
    //     dataIndex: 'asset_spec',
    //     key: 'asset_spec',
    //     width: '70px',
    //     align: 'center',
    //     editable: false,
    //     sorter: {
    //         compare: (a, b) => a.asset_spec.localeCompare(b.asset_spec),
    //     },
    // },
    {
        title: '권고사항 내용',
        dataIndex: 'suggest_desc',
        key: 'suggest_desc',
        width: '500px',
        align: 'left',
        ellipsis : true,
        editable: false,
        sorter: {
            compare: (a, b) => a.suggest_desc.localeCompare(b.suggest_desc),
        },
        render: (text) => (
          <span dangerouslySetInnerHTML={{ __html: text }} />
        ),
    },
];



// Risk 목록
export const riskColumnData = [
    // {
    //     title: '진단항목',
    //     dataIndex: 'measure_cd',
    //     key: 'measure_cd',
    //     width: '70px',
    //     align: 'center',
    //     editable: false,
    //     sorter: {
    //         compare: (a, b) => a.measure.localeCompare(b.measure),
    //     },
    // },
    {
        title: '위험코드',
        dataIndex: 'risk_cd',
        key: 'risk_cd',
        width: '70px',
        align: 'center',
        editable: false,
        sorter: {
            compare: (a, b) => a.measure.localeCompare(b.measure),
        },
    },
    {
        title: '위험시나리오',
        dataIndex: 'risk_desc',
        key: 'risk_desc',
        width: '430px',
        align: 'left',
        ellipsis : false,
        editable: false,
    },
];


// Corrective 목록
export const correctiveColumnData = [
    {
        title: '자산코드',
        dataIndex: 'asset_cd',
        key: 'asset_cd',
        width: '100px',
        align: 'center',
        editable: true,
        sorter: {
            compare: (a, b) => (a.asset_cd || '').localeCompare(b.asset_cd || ''),
        },
    },
    {
        title: '진단코드',
        dataIndex: 'measure_cd',
        key: 'measure_cd',
        width: '100px',
        align: 'center',
        editable: true,
        sorter: {
            compare: (a, b) => a.measure_cd.localeCompare(b.measure_cd),
        },
    },
    {
        title: '상태',
        dataIndex: 'current_status',
        key: 'current_status',
        width: '60px',
        align: 'left',
        ellipsis : false,
        editable: true,
    },
    {
        title: '점검결과',
        dataIndex: 'result_cd',
        key: 'result_cd',
        width: '50px',
        align: 'left',
        ellipsis : false,
        editable: true,
    },
    {
        title: '현황',
        dataIndex: 'corrective_desc',
        key: 'corrective_desc',
        width: '500px',
        align: 'left',
        ellipsis : false,
        editable: true,
    },
];


// Threat 목록
export const threatColumnData = [
    {
        title: '분류',
        dataIndex: 'threat_type',
        key: 'threat_type',
        width: '70px',
        align: 'center',
        ellipsis : true,
        fixed : true,
        sorter: {
            compare: (a, b) => a.threat_type.localeCompare(b.threat_type),
        },
        editable: false,
    },
    {
        title: '위협코드',
        dataIndex: 'threat_cd',
        key: 'threat_cd',
        width: '70px',
        align: 'center',
        ellipsis : true,
        fixed : true,
        sorter: {
            compare: (a, b) => a.threat_cd.localeCompare(b.threat_cd),
        },
        editable: false,
    },
    {
        title: '위협 항목',
        dataIndex: 'threat_nm',
        key: 'threat_nm',
        width: '150px',
        align: 'center',
        ellipsis : true,
        fixed : true,
        sorter: {
            compare: (a, b) => a.threat_nm.localeCompare(b.threat_nm),
        },
        editable: false,
    },
    {
        title: '내용',
        dataIndex: 'threat_desc',
        key: 'threat_desc',
        width: '300px',
        align: 'left',
        ellipsis : true,
        sorter: {
            compare: (a, b) => a.threat_desc.localeCompare(b.threat_desc),
        },
        editable: false,
    },
    {
        title: '위협강도',
        dataIndex: 'strength_grd',
        key: 'strength_grd',
        width: '70px',
        align: 'center',
        editable: false,
        className: 'edit_col',
    },
    {
        title: '발생빈도',
        dataIndex: 'frequency_grd',
        key: 'frequency_grd',
        width: '70px',
        align: 'center',
        editable: false,
        className: 'edit_col',
    },
    {
        title: '위협강도(점수)',
        dataIndex: 'strength_score',
        key: 'strength_score',
        width: '50px',
        align: 'center',
        className: 'fix_col',
    },
    {
        title: '발생빈도(점수)',
        dataIndex: 'frequency_score',
        key: 'frequency_score',
        width: '50px',
        align: 'center',
        className: 'fix_col',
    },
    {
        title: '위협평가 점수표',
        dataIndex: 'threat_score',
        key: 'threat_score',
        width: '70px',
        align: 'center',
        className: 'fix_col',
    },
    {
        title: '위협등급',
        dataIndex: 'threat_grd',
        key: 'threat_grd',
        width: '70px',
        align: 'center',
        className: 'fix_col',
        sorter: {
            compare: (a, b) => a.threat_grd.localeCompare(b.threat_grd),
        },
        render: (_ , rowData ) => {
            let tag_color ='';
            if(rowData.threat_grd == 'H') {
                tag_color = 'red';
            } else if(rowData.threat_grd == 'M') {
                tag_color = 'blue';
            } else {
                tag_color = 'green';
            }
            return <span style={{color:tag_color}}>{rowData.threat_grd}</span>
        },
    },
    {
        title: '위협등급(점수)',
        dataIndex: 'threat_grd_score',
        key: 'threat_grd_score',
        width: '50px',
        align: 'center',
        className: 'fix_col',
    },
];


// 자산 목록
export const assetColumnData = [
    {
        title: '비교',
        dataIndex: 'status',
        key: 'status',
        width: '50px',
        align: 'center',
        fixed : true,
        sorter: {
            compare: (a, b) => a.asset_cd.localeCompare(b.asset_cd),
        },
        editable: false,     
        render: (text, record) => (
            <span style={{ color: text === 'C' ? 'green' : text === 'U' ? 'red' : '' }}>
              {text}
            </span>
        ),
    },
    {
        title: '자산코드',
        dataIndex: 'asset_cd',
        key: 'asset_cd',
        width: '100px',
        align: 'center',
        fixed : true,
        sorter: {
            compare: (a, b) => a.asset_cd.localeCompare(b.asset_cd),
        },
        editable: false, 
    },
    {
        title: '자산명',
        dataIndex: 'asset_nm',
        key: 'asset_nm',
        width: '180px',
        fixed : true,
        align: 'center',
        editable: true,
        sorter: {
            compare: (a, b) => a.asset_nm.localeCompare(b.asset_nm),
        },
        // render: (_ , rowData ) => {
        //     return (
        //         <Typography.Link onClick={() => onClickDetailHandler({columnType: 'assetReport', report_id: rowData.report_id, asset_cd: rowData.asset_cd})}>
        //             {rowData.asset_nm}
        //         </Typography.Link>
        //     );
        // },
    },
    {
        title: '자산유형',
        dataIndex: 'asset_spec',
        key: 'asset_spec',
        width: '170px',
        align: 'center',
        editable: true,
        sorter: {
            compare: (a, b) => a.asset_spec.localeCompare(b.asset_spec),
        },
    },
    // {
    //     title: 'Group(사양)',
    //     dataIndex: 'asset_ver',
    //     key: 'asset_ver',
    //     width: '100px',
    //     align: 'center',
    //     editable: true,
    //     sorter: {
    //         compare: (a, b) => a.asset_ver.localeCompare(b.asset_ver),
    //     },
    // },
    // {
    //     title: 'OS및버전',
    //     dataIndex: 'os_ver',
    //     key: 'os_ver',
    //     width: '80px',
    //     align: 'center',
    //     editable: true,
    //     sorter: {
    //         compare: (a, b) => a.os_ver.localeCompare(b.os_ver),
    //     },
    // },
    {
        title: 'IP주소',
        dataIndex: 'asset_ip',
        key: 'asset_ip',
        width: '160px',
        align: 'center',
        editable: true,
        sorter: {
            compare: (a, b) => a.asset_ip.localeCompare(b.asset_ip),
        },
    },
    {
        title: 'MAC',
        dataIndex: 'mac_no',
        key: 'mac_no',
        width: '100px',
        align: 'center',
        editable: true,
        sorter: {
            compare: (a, b) => a.mac_no.localeCompare(b.mac_no),
        },
    },
    {
        title: 'SSH Port',
        dataIndex: 'ssh_port',
        key: 'ssh_port',
        width: '100px',
        align: 'center',
        editable: true,
        sorter: {
            compare: (a, b) => a.ssh_port-b.ssh_port,
        },
    },
    {
        title: 'ARCH',
        dataIndex: 'arch',
        key: 'arch',
        width: '100px',
        align: 'center',
        editable: true,
        sorter: {
            compare: (a, b) => a.arch.localeCompare(b.arch),
        },
    },
    {
        title: 'CPU',
        dataIndex: 'cpu',
        key: 'cpu',
        width: '100px',
        align: 'center',
        editable: true,
        sorter: {
            compare: (a, b) => a.cpu.localeCompare(b.cpu),
        },
    },
    // {
    //     title: '담당팀',
    //     dataIndex: 'depart_nm',
    //     key: 'depart_nm',
    //     width: '100px',
    //     align: 'center',
    //     editable: true,
    // },
    {
        title: '담당자',
        dataIndex: 'manager_nm',
        key: 'manager_nm',
        width: '80px',
        align: 'center',
        editable: true,
        sorter: {
            compare: (a, b) => a.manager_nm.localeCompare(b.manager_nm),
        },
    },
    {
        title: '관리자',
        dataIndex: 'supervisor_nm',
        key: 'assetsupervisor_nm_ver',
        width: '80px',
        align: 'center',
        editable: true,
        sorter: {
            compare: (a, b) => a.supervisor_nm.localeCompare(b.supervisor_nm),
        },
    },
    {
        title: '설치장소',
        dataIndex: 'location_nm',
        key: 'location_nm',
        width: '150px',
        align: 'center',
        ellipsis : true,
        editable: true,
        sorter: {
            compare: (a, b) => a.location_nm.localeCompare(b.location_nm),
        },
    },
    {
        title: '용도(서비스)',
        dataIndex: 'service_nm',
        key: 'service_nm',
        width: '150px',
        align: 'center',
        ellipsis : true,
        editable: true,
        sorter: {
            compare: (a, b) => a.service_nm.localeCompare(b.service_nm),
        },
    },
    {
        title: '기밀성',
        dataIndex: 'confidential_score',
        key: 'confidential_score',
        width: '70px',
        align: 'center',
        editable: true,
        className: 'edit_col',
        sorter: {
            compare: (a, b) => a.confidential_score - b.confidential_score,
        },
    },
    {
        title: '무결성',
        dataIndex: 'integrity_score',
        key: 'integrity_score',
        width: '70px',
        align: 'center',
        editable: true,
        className: 'edit_col',
        sorter: {
            compare: (a, b) => a.integrity_score - b.integrity_score,
        },
    },
    {
        title: '가용성',
        dataIndex: 'availability_score',
        key: 'availability_score',
        width: '70px',
        align: 'center',
        editable: true,
        className: 'edit_col',
        sorter: {
            compare: (a, b) => a.availability_score - b.availability_score,
        },
    },
    {
        title: '합계',
        dataIndex: 'score_sum',
        key: 'score_sum',
        width: '70px',
        align: 'center',
        className: 'fix_col',
        render: (_ , rowData ) => {
            let confidential = rowData.confidential_score?parseInt(rowData.confidential_score):0;
            let integrity = rowData.integrity_score?parseInt(rowData.integrity_score):0;
            let availability = rowData.availability_score?parseInt(rowData.availability_score):0;
            let score_sum = confidential + integrity  + availability;
            return (
                score_sum
            );
        },
    },
    {
        title: '보안등급',
        dataIndex: 'asset_grd',
        key: 'asset_grd',
        width: '70px',
        align: 'center',
        className: 'fix_col',
        sorter: {
            compare: (a, b) => a.asset_grd.localeCompare(b.asset_grd),
        },
        render: (_ , rowData ) => {
            let tag_color ='';
            if(rowData.asset_grd == 'H') {
                tag_color = 'red';
            } else if(rowData.asset_grd == 'M') {
                tag_color = 'blue';
            } else {
                tag_color = 'green';
            }
            return <span style={{color:tag_color}}>{rowData.asset_grd}</span>
        },
    },
    {
        title: '자산평가',
        dataIndex: 'asset_rnk',
        key: 'asset_rnk',
        width: '70px',
        align: 'center',
        className: 'fix_col',
        sorter: {
            compare: (a, b) => a.asset_rnk - b.asset_rnk,
        },
        render: (_ , rowData ) => {
            let tag_color ='';
            if(rowData.asset_rnk == '3') {
                tag_color = 'red';
            } else if(rowData.asset_rnk == '2') {
                tag_color = 'blue';
            } else {
                tag_color = 'green';
            }
            return <span style={{color:tag_color}}>{rowData.asset_rnk}</span>
        },
    },

];

// export const assetColumnDataFix = assetColumnData.map(column => ({
//     ...column,
//     editable: false
// }));
